import { useState, useMemo, useEffect, useCallback, useRef } from 'react'
import { Table, Footer, Modal, Status, Button, useWindowContext, noop } from '@iqueue/ui-kit'
import GasVolume from '../../components/gasAndOil/GasVolume'
import Measurement, { UNIT_PRESSURE } from '../../components/gasAndOil/Measurement'
import StatisticsPresenter from '../../api/statisticsPresenter'
import useTranslate, { t } from '../../hooks/useTranslate'
import './translations'

function Card({ image, title, onClick }) {
  return <div className="gas-and-oil-summary-card" onClick={ onClick }>
    { image ? <img src={ image } alt="Card visual"/> : <div className="placeholder-image"/> }
    <Footer>
      <div className={ 'iq-spacer' }>
        <b>{ title }</b>
      </div>
    </Footer>
  </div>
}

export default function ReportPage() {
  const tableRef = useRef()
  const { setTitle, togglePaddings, toggleScrollbars } = useWindowContext()
  const locale = useTranslate()
  const translatedTitle = useMemo(() => t('menu.reports'), [locale])

  const [state, setState] = useState([])
  const [opened, setOpened] = useState(false)

  const schema = useMemo(() => {
    return [{
      key: 'name',
      title: t('report.table.name'),
    }, {
      key: 'operatingFactor',
      width: '20rem',
      title: t('report.table.operationFactor'),
      renderExcel: (value) => Math.round(value * 100) + '%',
      render: (value, item) => {
        return <Status horizontal progress={ Math.round(value * 100) }/>
      },
    }, {
      key: 'pressurePlume',
      title: t('report.table.pipelinePressure'),
      width: '20rem',
      render: (value) => <Measurement unit={ UNIT_PRESSURE }>{ value }</Measurement>,
    }, {
      key: 'pressureWell',
      title: t('report.table.wellPressure'),
      width: '20rem',
      render: (value) => <Measurement unit={ UNIT_PRESSURE }>{ value }</Measurement>,
    }, {
      key: 'type',
      title: t('report.table.type'),
      width: '25rem',
      center: true,
      render: (v) => v ? t(`type.node.${ v }`) : 'N/A',
    }, {
      key: 'volume',
      title: t('report.table.volume'),
      width: '10rem',
      center: true,
      render: (value) => <GasVolume>{ value }</GasVolume>,
    }]
  }, [t, locale])

  const fetchData = useCallback(async () => {
    await StatisticsPresenter.getNodesDaily().then((item) => {
      setState(item)
    })
  }, [])

  useEffect(() => {
    setTitle(t('menu.reports'))
    togglePaddings(false)
    toggleScrollbars(true)
  }, [translatedTitle])

  useEffect(() => {
    fetchData().catch(err => console.error(err))
  }, [])

  return <>
    <div className={ 'production-summary-cards-wrapper' }>
      <div className={ 'cards' }>
        <Card
          image={ '/response/1.png' }
          title={ t('report.wellReportTitleAlt') }
          onClick={ () => setOpened(true) }
        />

        <Card
          image={ '/response/1.png' }
          title={ t('report.wellReportTitleAlt') }
          onClick={ () => setOpened(true) }
        />

        <Card
          image={ '/response/1.png' }
          title={ t('report.wellReportTitleAlt') }
          onClick={ () => setOpened(true) }
        />
      </div>
    </div>

    <Modal
      title={ t('report.wellReportTitle') }
      isOpened={ opened }
      fullscreen
      onClose={ () => setOpened(false) }
    >
      <Table
        entries={ state }
        ref={ tableRef }
        schema={ schema }
        minWidth={ '140rem' }
      >
        <Footer
          className={ 'iq-pagination' }
        >
          <Button
            primary
            onClick={ () => tableRef.current.exportToExcel('report', 'report') }
          >
            { t('report.download') }
          </Button>
        </Footer>
      </Table>
    </Modal>
  </>
}
